const PricingFirstLoad = () => {
  // setTimeout(() => {
  //   document?.getElementById("first-div")?.scrollIntoView({
  //     behavior: "smooth",
  //     block: "start",
  //   });
  // }, 300);
};
export default PricingFirstLoad;
